import React from 'react';
import styles from './app.button.module.css';

//
//

export type ButtonVariant = 'contained' | 'outline' | 'text';

export type ButtonSize = 'small' | 'medium' | 'large';

type ButtonType = 'button' | 'submit' | 'reset';

interface AppButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  isLoading?: boolean;
  variant?: ButtonVariant;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  size?: ButtonSize;
  type?: ButtonType;
}

export const AppButton: React.FC<AppButtonProps> = ({
  children,
  startIcon,
  endIcon,
  isLoading = false,
  variant = 'contained',
  size = 'large',
  disabled = false,
  onClick,
  type = 'button',
  ...props
}) => {
  // Determine which CSS classes to apply based on props
  const buttonClasses = [styles.button, styles[variant], styles[size], disabled || isLoading ? styles.disabled : '']
    .filter(Boolean)
    .join(' ');

  //

  return (
    <button type={type} className={buttonClasses} onClick={onClick} disabled={disabled || isLoading} {...props}>
      {isLoading ? (
        <div className={styles.spinner} />
      ) : (
        <>
          {startIcon && <span className={styles.startIcon}>{startIcon}</span>}
          <span>{children}</span>
          {endIcon && <span className={styles.endIcon}>{endIcon}</span>}
        </>
      )}
    </button>
  );
};
